import { render } from "./ModalAlertBanner.vue?vue&type=template&id=0b4fe1f7"
import script from "./ModalAlertBanner.vue?vue&type=script&lang=js"
export * from "./ModalAlertBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__